// Imports
  // React
  import React, { useState } from "react"
  // Decimal JS
  import Decimal from "decimal.js-light";




// Context

	const CartContext = React.createContext(
		{

			// Cart Items
				items: [] ,

			// Items functions
				addItems: () => {},
				removeItems: () => {} ,
				getItem: () => {},
				
			//Cart functions
				getTotal: () => {},
				getPrice: () => {},
				clearItems: () => {}

		}
	);




// Provider

	const CartContextProvider = ( {children} ) => {


		// Cart Items
		const [itemsInCart, setItemsInCart] = useState( JSON.parse(localStorage.getItem('storagedCart')) || [] );

		// Ver si ya existe el item en el carrito
		function isItemInCart(name){
			return itemsInCart.some( i => i.name === name);
		};


		// Items functions
			
			// Si ya existe lo modificamos, si no existe lo agregamos
			const addToCart = (item, qty) => {
				if(isItemInCart(item.name)){
					let index = itemsInCart.findIndex(i => i.name === item.name);
					let copyCart = [...itemsInCart];
					copyCart[index].qty += qty;
					setItemsInCart(copyCart)
				}
				else{
					const itemToAdd = { ...item, qty};
					setItemsInCart( [...itemsInCart, itemToAdd] );
				}
			}
			
			// Si ya existe lo borramos
			const removeFromCart = (item, qty) => {
				if(isItemInCart(item.name)){
					let index = itemsInCart.findIndex(i => i.name === item.name);
					let copyCart = [...itemsInCart];
					if(copyCart[index].qty > 1){
						copyCart[index].qty -= qty;
						setItemsInCart(copyCart)
					}
					else{
						itemsInCart.splice(index,1);
						let copyCart = [...itemsInCart];
						setItemsInCart(copyCart)
					}
				}
			}

			// Obtener el item del carrito
			function getItemInCart(name){
				return itemsInCart.find( i => i.name === name);
			}


		//Cart functions

			// Si queremos saber qué cantidad de todos los items hay en el carrito
			function howManyTotal(){
				let total=0;
				for(var i=0; i<itemsInCart.length; i++) {
					let mappingItems = itemsInCart[i];
					total += parseFloat(mappingItems.qty);
				}
				return total;
			}

			// Si queremos saber el precio de todos los items hay en el carrito
			function howMuchTotal(){
				let price=0;
				let priceRounded=0
				for(var i=0; i<itemsInCart.length; i++) {
					let mappingItems = itemsInCart[i];
					let itemPrice = parseFloat(mappingItems.price);
					let itemQty = parseFloat(mappingItems.qty);
					price += Math.round((itemPrice * itemQty) * 1e2) / 1e2;
					priceRounded = Math.round(price * 1e2) / 1e2;
				}
				return priceRounded
			}

			// Si queremos borrar todos los items
			const clearCart = () => {
				setItemsInCart( [] );
				localStorage.setItem('storagedCart', JSON.stringify([]));
			}


		// Incluir funciones al context

		const context = {
			items: itemsInCart ,
			addItems: addToCart ,
			removeItems: removeFromCart ,
			getItem: getItemInCart ,
			getTotal: howManyTotal ,
			getPrice: howMuchTotal ,
			clearItems: clearCart
		}


		// Context provider
		return (
			<CartContext.Provider value={context}>
				{children}
			</CartContext.Provider>
		)
		
	}


	export {CartContext, CartContextProvider}